
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { ExternalLink } from "lucide-react";
import { SeoResult } from "../types";

interface PagesTabProps {
  result: SeoResult;
}

export const PagesTab = ({ result }: PagesTabProps) => {
  return (
    <div className="space-y-4">
      <Card>
        <CardHeader>
          <CardTitle>Top Performing Pages</CardTitle>
          <CardDescription>Analysis of your most important pages</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            {result.pages.map((page, index) => (
              <div key={index} className="border rounded-lg p-4 hover:bg-muted/50">
                <div className="flex justify-between items-start">
                  <div>
                    <a 
                      href={page.url} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="text-blue-500 hover:underline font-medium flex items-center"
                    >
                      {page.url.replace(/^https?:\/\//, '')}
                      <ExternalLink className="w-3 h-3 ml-1" />
                    </a>
                    <h4 className="text-base font-semibold mt-1">{page.title}</h4>
                    <p className="text-sm text-muted-foreground mt-1">{page.metaDescription}</p>
                  </div>
                  <Badge className={`
                    ${page.score >= 80 ? "bg-green-100 text-green-800" : 
                      page.score >= 60 ? "bg-yellow-100 text-yellow-800" : 
                      "bg-red-100 text-red-800"}
                  `}>
                    Score: {page.score}/100
                  </Badge>
                </div>
                
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
                  <div className="text-center p-2 bg-muted/50 rounded">
                    <div className="text-sm font-medium">{page.wordCount}</div>
                    <div className="text-xs">Words</div>
                  </div>
                  <div className="text-center p-2 bg-muted/50 rounded">
                    <div className="text-sm font-medium">{page.loadTime}</div>
                    <div className="text-xs">Load Time</div>
                  </div>
                  <div className="text-center p-2 bg-muted/50 rounded">
                    <div className="text-sm font-medium">{page.internalLinks}</div>
                    <div className="text-xs">Internal Links</div>
                  </div>
                  <div className="text-center p-2 bg-muted/50 rounded">
                    <div className="text-sm font-medium">{page.imagesWithAlt}/{page.images}</div>
                    <div className="text-xs">Images with Alt</div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PagesTab;
